import { render, staticRenderFns } from "./confirmDelive.vue?vue&type=template&id=7f107c15&scoped=true"
import script from "./confirmDelive.vue?vue&type=script&lang=js"
export * from "./confirmDelive.vue?vue&type=script&lang=js"
import style0 from "./confirmDelive.vue?vue&type=style&index=0&id=7f107c15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f107c15",
  null
  
)

export default component.exports